import { useState, useEffect } from 'react'

export const getGradient = (min, max, range) => {
  const minInPercent = ((min - range[0]) / (range[1] - range[0])) * 100
  const maxInPercent = ((max - range[0]) / (range[1] - range[0])) * 100
  return `linear-gradient(to right, #909196 0%, #909196 ${minInPercent}%, #0071dc ${minInPercent}%,  #0071dc ${maxInPercent}%, #909196 ${maxInPercent}%, #909196 100%)`
}

// eslint-disable-next-line max-params
export function useSliderPosition(
  min,
  max,
  stepSize,
  defaultMin = null,
  defaultMax = null,
  minSliderRef = HTMLInputElement | null,
  maxSliderRef = HTMLInputElement | null,
  sliderTrackRef = HTMLDivElement | null
) {
  let start = parseInt(defaultMin ?? min)
  const end = parseInt(defaultMax ?? max)

  // In case of invalid data, making start = end
  if (start > end) {
    start = end
  }

  const [state, setState] = useState({
    start,
    end,
  })

  useEffect(() => {
    setState({
      start,
      end,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [min, max, defaultMin, defaultMax, stepSize])

  useEffect(() => {
    if (minSliderRef && maxSliderRef && sliderTrackRef) {
      const backGroundGradient = getGradient(minSliderRef.valueAsNumber, maxSliderRef.valueAsNumber, [min, max])
      sliderTrackRef.style.background = backGroundGradient
    }
  }, [state.start, state.end, min, max, stepSize, minSliderRef, maxSliderRef, sliderTrackRef])

  useEffect(() => {
    if (minSliderRef && maxSliderRef && minSliderRef.valueAsNumber === max) {
      minSliderRef.style.zIndex = 1
      maxSliderRef.style.zIndex = 0
    }
  }, [state.start, minSliderRef])

  useEffect(() => {
    if (minSliderRef && maxSliderRef && maxSliderRef.valueAsNumber === min) {
      minSliderRef.style.zIndex = 0
      maxSliderRef.style.zIndex = 1
    }
  }, [state.end, maxSliderRef])

  const setStartValue = (value) => {
    setState({
      ...state,
      start: value,
    })
  }

  const setEndValue = (value) => {
    setState({
      ...state,
      end: value,
    })
  }

  return { state, setStartValue, setEndValue }
}
